export enum warehouseTypeEnum {
  FIXED,
  TRANSITORY,
}
